<mdb-form-control [formGroup]="formGroup()">
  <mdb-select
    [clearButton]="clear()"
    [filterPlaceholder]="('SEARCH'| translate) + '...'"
    [filter]="filter()"
    [multiple]="multiple()"
    [notFoundMsg]="'NO_RESULTS_FOUND' | translate"
    [optionsSelectedLabel]="'OPTIONS_SELECTED' | translate"
    formControlName="{{ controlName() }}"
    placeholder="{{placeholder() ? (placeholder()!|translate) : null}}"
    (search)="search.emit($event)"
    (opened)="opened.emit()">
    @for (option of options(); track option) {
      <mdb-option
        [value]="optionValueSelector() ? getOptionValue(option) : option">
        {{ this.translateOptionLabels() ? (getOptionLabel(option) | translate) : getOptionLabel(option) }}
      </mdb-option>
    }
  </mdb-select>
  @if (!hideLabel()) {
    <label class="form-label" mdbLabel>
      {{ label() | translate }}
      @if (isRequired()) {
        <span>*</span>
      }
    </label>
  }

  @if (isRequired() &&
  control?.hasError('required') &&
  (control?.dirty || control?.touched)) {
    <mdb-error>
      {{ label() | translate }} {{ 'VALIDATION.IS_REQUIRED' | translate }}.
    </mdb-error>
  }

  @if (this.loading()) {
    <div class="autocomplete-loader spinner-border" role="status"></div>
  }
</mdb-form-control>
